'use client';
import React, { useState, useEffect } from 'react';

interface HeroSlide {
  id: number;
  label: string;
  eyebrow: string;
  title: string;
  subtitle: string;
  description: string;
  cta: string;
  ctaHref: string;
  image: string;
  alt: string;
}

const slides: HeroSlide[] = [
{
  id: 1,
  label: 'Seasonal Blend',
  eyebrow: 'Introducing',
  title: 'Diamond Street Morning Blend',
  subtitle: 'Our signature house roast, crafted for Portland',
  description: 'Chocolate, Caramel, Toasted Almond',
  cta: 'Order Now',
  ctaHref: '#contact',
  image: "https://images.unsplash.com/photo-1659334355755-95b4cb97357a",
  alt: 'Freshly roasted coffee beans with steam rising from a cup on a wooden table'
},
{
  id: 2,
  label: 'Single Origin',
  eyebrow: 'Now Brewing',
  title: 'Ethiopian Yirgacheffe Natural',
  subtitle: 'A vibrant single origin from the birthplace of coffee',
  description: 'Blueberry, Jasmine, Dark Chocolate',
  cta: 'Learn More',
  ctaHref: '#menu',
  image: "https://images.unsplash.com/photo-1608637568584-63168b98c9db",
  alt: 'Close-up of Ethiopian coffee cherries on the branch in a lush green farm'
},
{
  id: 3,
  label: 'Cold Brew',
  eyebrow: 'Summer Special',
  title: 'Slow-Steeped Cold Brew',
  subtitle: '18-hour cold brew, smooth and bold',
  description: 'Dark Chocolate, Brown Sugar, Vanilla',
  cta: 'Visit Us',
  ctaHref: '#contact',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_183b20cea-1772776393668.png",
  alt: 'Cold brew coffee in a tall glass with ice cubes and a straw on a cafe counter'
},
{
  id: 4,
  label: 'Espresso',
  eyebrow: 'Classic Favorite',
  title: 'Bella Crema Espresso',
  subtitle: 'Rich, velvety espresso with a golden crema',
  description: 'Dark Chocolate, Hazelnut, Dried Cherry',
  cta: 'See Menu',
  ctaHref: '#menu',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bdcc1fff-1776269869463.png",
  alt: 'Espresso shot being pulled from a professional espresso machine with golden crema'
},
{
  id: 5,
  label: 'Community',
  eyebrow: 'Since 1994',
  title: 'Portland\'s Community Coffee House',
  subtitle: 'Where everyone is welcome at our table',
  description: 'Warmth, Connection, Great Coffee',
  cta: 'Our Story',
  ctaHref: '#about',
  image: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=1600&q=80',
  alt: 'Cozy coffee shop interior with warm lighting, wooden tables, and customers enjoying their drinks'
}];


export default function HeroSection() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      handleSlideChange((activeSlide + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [activeSlide]);

  const handleSlideChange = (index: number) => {
    if (index === activeSlide) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveSlide(index);
      setIsTransitioning(false);
    }, 300);
  };

  const current = slides[activeSlide];

  return (
    <section data-component-id="src/components/HeroSection.tsx:103:4" data-component-path="src/components/HeroSection.tsx" data-component-line="103" data-component-end-line="193" data-component-file="HeroSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22relative%20w-full%20overflow-hidden%22%7D" className="relative w-full overflow-hidden" style={{ minHeight: '70vh' }}>
      {/* Background image */}
      <div data-component-id="src/components/HeroSection.tsx:105:6" data-component-path="src/components/HeroSection.tsx" data-component-line="105" data-component-end-line="121" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={`absolute inset-0 transition-opacity duration-500 ${
        isTransitioning ? 'opacity-0' : 'opacity-100'}`
        }>
        
        <img data-component-id="src/components/HeroSection.tsx:110:8" data-component-path="src/components/HeroSection.tsx" data-component-line="110" data-component-end-line="114" data-component-file="HeroSection.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%22%7D"
          src={current.image}
          alt={current.alt}
          className="w-full h-full object-cover"
          style={{ minHeight: '70vh' }} />
        
        {/* Dark overlay */}
        <div data-component-id="src/components/HeroSection.tsx:117:8" data-component-path="src/components/HeroSection.tsx" data-component-line="117" data-component-end-line="119" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%22%7D"
          className="absolute inset-0"
          style={{ background: 'rgba(18,9,0,0.55)' }} />
        
      </div>

      {/* Content */}
      <div data-component-id="src/components/HeroSection.tsx:124:6" data-component-path="src/components/HeroSection.tsx" data-component-line="124" data-component-end-line="165" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={`relative z-10 container-brand flex flex-col justify-center py-20 md:py-32 transition-all duration-500 ${
        isTransitioning ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'}`
        }
        style={{ minHeight: '70vh' }}>
        
        <div data-component-id="src/components/HeroSection.tsx:130:8" data-component-path="src/components/HeroSection.tsx" data-component-line="130" data-component-end-line="164" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-2xl%22%7D" className="max-w-2xl">
          <p data-component-id="src/components/HeroSection.tsx:131:10" data-component-path="src/components/HeroSection.tsx" data-component-line="131" data-component-end-line="136" data-component-file="HeroSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-brand-gold%20text-sm%20tracking-widest%20uppercase%20mb-3%22%7D"
            className="text-brand-gold text-sm tracking-widest uppercase mb-3"
            style={{ fontFamily: "'Sofia Sans Condensed', sans-serif", fontWeight: 600 }}>
            
            {current.eyebrow}
          </p>
          <h2 data-component-id="src/components/HeroSection.tsx:137:10" data-component-path="src/components/HeroSection.tsx" data-component-line="137" data-component-end-line="146" data-component-file="HeroSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-white%20mb-4%20leading-tight%22%7D"
            className="text-white mb-4 leading-tight"
            style={{
              fontFamily: "'Petrona', serif",
              fontWeight: 600,
              fontSize: 'clamp(2rem, 5vw, 3.5rem)'
            }}>
            
            {current.title}
          </h2>
          <div data-component-id="src/components/HeroSection.tsx:147:10" data-component-path="src/components/HeroSection.tsx" data-component-line="147" data-component-end-line="160" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-6%22%7D" className="mb-6">
            <p data-component-id="src/components/HeroSection.tsx:148:12" data-component-path="src/components/HeroSection.tsx" data-component-line="148" data-component-end-line="153" data-component-file="HeroSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%2F90%20text-lg%20mb-1%22%7D"
              className="text-white/90 text-lg mb-1"
              style={{ fontFamily: "'Sofia Sans Condensed', sans-serif" }}>
              
              {current.subtitle}
            </p>
            <p data-component-id="src/components/HeroSection.tsx:154:12" data-component-path="src/components/HeroSection.tsx" data-component-line="154" data-component-end-line="159" data-component-file="HeroSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-brand-gold-light%20text-sm%20tracking-wide%22%7D"
              className="text-brand-gold-light text-sm tracking-wide"
              style={{ fontFamily: "'Sofia Sans Condensed', sans-serif" }}>
              
              {current.description}
            </p>
          </div>
          <a data-component-id="src/components/HeroSection.tsx:161:10" data-component-path="src/components/HeroSection.tsx" data-component-line="161" data-component-end-line="163" data-component-file="HeroSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22btn-primary%22%7D" href={current.ctaHref} className="btn-primary">
            {current.cta}
          </a>
        </div>
      </div>

      {/* Slide tabs */}
      <div data-component-id="src/components/HeroSection.tsx:168:6" data-component-path="src/components/HeroSection.tsx" data-component-line="168" data-component-end-line="192" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-0%20left-0%20right-0%20z-20%22%7D" className="absolute bottom-0 left-0 right-0 z-20">
        <div data-component-id="src/components/HeroSection.tsx:169:8" data-component-path="src/components/HeroSection.tsx" data-component-line="169" data-component-end-line="191" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container-brand%22%7D" className="container-brand">
          <ul data-component-id="src/components/HeroSection.tsx:170:10" data-component-path="src/components/HeroSection.tsx" data-component-line="170" data-component-end-line="190" data-component-file="HeroSection.tsx" data-component-name="ul" data-component-content="%7B%22elementName%22%3A%22ul%22%2C%22className%22%3A%22flex%20overflow-x-auto%20gap-0%20pb-0%22%7D" className="flex overflow-x-auto gap-0 pb-0">
            {slides.map((slide, index) =>
            <li data-component-id="src/components/HeroSection.tsx:172:12" data-component-path="src/components/HeroSection.tsx" data-component-line="172" data-component-end-line="188" data-component-file="HeroSection.tsx" data-component-name="li" data-component-content="%7B%22elementName%22%3A%22li%22%2C%22className%22%3A%22flex-shrink-0%22%7D" key={slide.id} className="flex-shrink-0">
                <button data-component-id="src/components/HeroSection.tsx:173:16" data-component-path="src/components/HeroSection.tsx" data-component-line="173" data-component-end-line="187" data-component-file="HeroSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                onClick={() => handleSlideChange(index)}
                className={`flex items-center gap-2 px-4 py-3 text-xs tracking-widest uppercase transition-all duration-200 border-t-2 ${
                index === activeSlide ?
                'bg-brand-maroon text-white border-brand-gold' : 'bg-black/40 text-white/70 border-transparent hover:bg-black/60 hover:text-white'}`
                }
                style={{ fontFamily: "'Sofia Sans Condensed', sans-serif", fontWeight: 600 }}>
                
                  <span data-component-id="src/components/HeroSection.tsx:181:18" data-component-path="src/components/HeroSection.tsx" data-component-line="181" data-component-end-line="184" data-component-file="HeroSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                  className={`w-2 h-2 rounded-full flex-shrink-0 ${
                  index === activeSlide ? 'bg-brand-gold' : 'bg-white/40'}`
                  } />
                
                  {slide.label}
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
    </section>);

}